import { useFeatureFlagEnabled } from '@frameio/feature-flags';
import { useIsIntegrationClient } from '@frameio/shared/contexts/ClientNameContext';

export const useIsAdvancedSearchEnabled = () => {
  const isIntegrationClient = useIsIntegrationClient();
  return useFeatureFlagEnabled('v4.full_page_search') && !isIntegrationClient;
};
